// extracted by mini-css-extract-plugin
module.exports = {"selected":"CardList_selected__2FTS1","checked":"CardList_checked__3WBt1"};